import * as types from "./validacaoSolicitacao.actionTypes";

export default {
  validar: data => ({
    type: types.DECA_VALIDACAO_POST,
    payload: data
  }),
  setValidar: data => ({
    type: types.DECA_VALIDACAO_SET,
    payload: data
  }),
  closeModal: () => ({
    type: types.MODAL_CLOSE
  }),
}
